// extracted by mini-css-extract-plugin
export default {"goToHome":"styles_goToHome__cMPaP"};